module.exports = "/images/android-chrome-256x256.png?b994b9f";


//////////////////
// WEBPACK FOOTER
// ./resources/img/favicon/android-chrome-256x256.png
// module id = 21
// module chunks = 0